<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" class="px-0 py-0">
        <!-- Selected Filters -->
        <reports-selected-filters
          :reset-selections="resetSelections"
          :class="smAndDown ? 'pa-3' : ''"
        />

        <v-divider v-show="!smAndDown" class="mt-3"></v-divider>

        <!-- All Filter Sections -->
        <div v-show="!smAndDown" class="filter-sidebar">
          <reports-all-filters />
        </div>
        <v-card v-show="smAndDown" class="pa-3">
          <reports-all-filters />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
  import ReportsAllFilters from './ReportsAllFilters.vue';
  import ReportsSelectedFilters from './ReportsSelectedFilters.vue';
  import { useReportsStore } from '../../store';
  import { useDisplay } from 'vuetify';
  import { computed } from 'vue';

  const reportsStore = useReportsStore();
  const { smAndDown } = useDisplay();

  const resetSelections = () => {
    reportsStore.selectedSubjects = [];
    reportsStore.selectedFormats = [];
    reportsStore.selectedStandards = [];
    reportsStore.setGradeRange(0, 12); // Reset grade range to K-12
  };
</script>

<style scoped lang="scss">
  .filters-header {
    font-weight: 500;
  }

  .small-select {
    max-width: 210px;
    padding-right: 12px;

    :deep(.v-field--appended) {
      padding-inline-end: 0;
    }

    :deep(.v-field) {
      border-color: rgb(var(--v-theme-lighter-grey)) !important;
    }

    :deep(.v-field__outline) {
      --v-field-border-width: 1px !important;
    }

    :deep(.v-input--density-compact) {
      --v-input-control-height: 32px;
      --v-input-padding-top: 5px;
    }

    :deep(.v-input__control) {
      height: 32px;
    }

    :deep(.v-field__input) {
      min-height: 0 !important;
    }

    :deep(.v-field__append-inner .v-icon) {
      transition: transform 0.2s ease;
    }

    :deep(.mdi-chevron-down) {
      color: rgb(var(--v-theme-blue)) !important;
      opacity: 1;
    }

    :deep(.v-text-field--box .v-input__slot),
    :deep(.v-text-field--outline .v-input__slot) {
      min-height: auto !important;
      display: flex !important;
      align-items: center !important;
    }

    :deep(.v-field) {
      min-height: 32px !important;
      font-size: 12px !important;
    }

    :deep(.mdi-menu-down) {
      display: none !important;
    }
  }
</style>
